export default [
  {
    name: 'scheduleManagment',
    label: 'labels.scheduleManagement',
    permissionKey: 'journey_schedule_management',
    children: [
      {
        name: 'journey_schedule_settings',
        label: 'labels.editJourneyScheduleSettings',
        permissionKey: 'journey_schedule_settings'
      },
      {
        name: 'journey_schedule_automation',
        label: 'labels.journeyScheduleAutomation',
        permissionKey: 'journey_schedule_automation'
      },
      {
        name: 'journey_schedule_manual',
        label: 'labels.journeyScheduleManual',
        permissionKey: 'journey_schedule_manual'
      }
    ]
  }
]
